// ACTION TYPE FETCH_PERSONALIZED_PAGE_HTML
export const FETCH_PERSONALIZED_PAGE_HTML = 'FETCH_PERSONALIZED_PAGE_HTML';

// ACTION CREATOR fetchPersonalizedPageHtml
export const fetchPersonalizedPageHtml = (query, backend) => ({
  type: FETCH_PERSONALIZED_PAGE_HTML,
  query,
  backend,
});
// ACTION TYPE SAVE_PERSONALIZED_PAGE_HTML
export const SAVE_PERSONALIZED_PAGE_HTML = 'SAVE_PERSONALIZED_PAGE_HTML';

// ACTION CREATOR savePersonalizedPageHtml
export const savePersonalizedPageHtml = (value) => ({
  type: SAVE_PERSONALIZED_PAGE_HTML,
  value,
});

// ACTION TYPE SET_LOADING_PERSONALIZED
export const SET_LOADING_PERSONALIZED = 'SET_LOADING_PERSONALIZED';

// ACTION CREATOR setLoadingPersonalized
export const setLoadingPersonalized = (value) => ({
  type: SET_LOADING_PERSONALIZED,
  value,
});
